function openContactModal() {
    document.querySelector('.js-contact-modal').style.display = 'block';
}

function closeModal() {
    document.querySelector('.js-contact-modal').style.display = 'none';
}

function openWhatsApp() {
    window.open('https://api.whatsapp.com/send?phone=33756780359&text=Bonjour,%20j%27aimerais%20obtenir%20un%20devis%20pour%20...', '_blank');
    closeModal();
}

// Close modal when clicking outside
window.onclick = function(event) {
    if (event.target == document.querySelector('.js-contact-modal')) {
        closeModal();
    }
}

document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('.js-open-contact-modal').addEventListener('click', openContactModal);
    document.querySelector('.js-whatsapp-button').addEventListener('click', openWhatsApp);
});